import React from 'react';
import Footer from '../Footer';
 
function GeneralAwareness() {
    return (
        <div>
            <div>
                <div className="row contain-text">
                <img src="images/gaimg.jpg" alt="Snow" style={{width: '100%'}} />
                </div>
                <div className="container">
                <div className="row row-content">
                    <h1 style={{color: 'yellowgreen'}}>What is Mental Illness</h1>
                    <h4 style={{color: 'green'}}>
                    <i>
                        A mental illness is a physical illness of the brain that causes disturbances in thinking, behavior, energy or emotion that make it difficult to cope with the ordinary demands of life. Research is starting to uncover the complicated causes of these diseases which can include genetics, brain chemistry, brain structure, experiencing trauma and/or having another medical condition, like heart disease.
                    </i>
                    </h4>
                </div>
                </div>
                <div className="container">
                <div className="row row-content">
                    <h1 style={{color: 'yellowgreen'}}>What is Mental Health</h1>
                    <h4 style={{color: 'green'}}>
                    <i>
                        Mental health includes our emotional, psychological, and social well-being. It affects how we think, feel, and act. It also helps determine how we handle stress, relate to others, and make choices. Mental health is important at every stage of life, from childhood and adolescence through adulthood. Over the course of your life, if you experience mental health problems, your thinking, mood, and behavior could be affected.          
                    </i>
                    </h4>
                </div>
                </div>
                <div className="container">
                <div className="row row-content">
                    <h1 style={{color: 'yellowgreen'}}>Early Warning Signs</h1>
                    <h4 style={{color: 'green'}}>
                    <i>
                    </i><ul><i>
                        <li>Eating or sleeping too much or too little</li>
                        <li>Pulling away from people and usual activities</li>
                        <li>Having low or no energy</li>
                        <li>Feeling numb or like nothing matters</li>
                        <li>Having unexplained aches and pains</li>
                        <li>Feeling helpless or hopeless</li>
                        <li>Smoking, drinking, or using drugs more than usual</li>
                        <li>Feeling unusually confused, forgetful, on edge, angry, upset, worried, or scared</li>
                        <li>Yelling or fighting with family and friends</li>
                        <li>Experiencing severe mood swings that cause problems in relationships</li>
                        <li>Having persistent thoughts and memories you can't get out of your head</li>
                        <li>Hearing voices or believing things that are not true</li>
                        <li>Thinking of harming yourself or others</li>
                        <li>Inability to perform daily tasks like taking care of your kids or getting to work or school</li>
                        </i>
                    </ul></h4>
                </div>
                </div>
                <div className="container">
                <div className="row row-content">
                    <h1 style={{color: 'yellowgreen'}}>General Tips for Mental health</h1>
                    <p>Our bodies and our minds are connected. When you take care of your body, you also take care of your mind.</p>
                    <h4 style={{color: 'green'}}>
                    <i>
                        <ul>
                        <li>
                            <b>Eat well</b>
                            <p>Food is our fuel. It gives us important nutrients that help our bodies work. It makes sense that the better we eat, the better we work. Our brains work better, too. Research shows that the food we eat is a big part of mental health. Healthy foods like fruits, vegetables and whole grains give us the nutrients to work our best.</p>
                        </li>
                        <li>
                            <b>Exercise</b>
                            <p>Exercise is good for your body. But did you know that it is also good for mental health? Here are a few ways exercise can help:
                            </p><ul style={{color: 'grey'}}>
                            <li>Exercise is good for your body.</li>
                            <li>It helps us cope with stress.</li>
                            <li>It lowers anxiety.</li>
                            <li>It lifts our mood.</li>
                            <li>It boosts our energy.</li>
                            <li>It helps us feel good about ourselves.</li>
                            <li>It helps us sleep well.</li>
                            </ul>
                            <p />
                        </li>
                        <li>
                            <b>Get enough sleep</b>
                            <p>
                            Sleep has a huge effect on mental health. When we get enough sleep, it is easier to cope with stress, handle problems, concentrate, think positively and remember things.
                            The exact amount of sleep you need is based on your own body. You know that you are getting enough sleep when you do not feel sleepy during the day.
                            </p>
                        </li>
                        <li>
                            <b>Practice healthy thinking</b>
                            <p>
                            Good mental health does not mean that we only ever have happy thoughts. Sad or upsetting things are part of life. Problems are also part of life. Good mental health means looking at the situation for what it really is. The way we think about something has a big effect on the way we feel.
                            </p>
                        </li>
                        <li>
                            <b>Reach out</b>
                            <p>
                            The people in our lives are a big part of our own mental health. We help each other out, share the good times, and learn from each other.Social networks are a big part of our overall mental health. Our social networks are the people in our lives who support us, celebrate our successes and help us deal with problems.
                            </p>
                        </li>
                        <li>
                            <b>Get help when you need it</b>
                            <p>
                            To stay healthy, we need to find help when we start to feel unwell. The same is true for mental health. Mental health problems are easier to care for when they are caught quickly. If you are feeling unwell and nothing seems to help, it is important to talk to your doctor or counsellor.                  </p>
                        </li>
                        </ul>
                    </i>
                    </h4>
                </div>
                </div>
            </div>
            <Footer />
            </div>
    )
}

export default GeneralAwareness
